import { Link } from 'react-router-dom';
import { comics, featuredComics } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComic = comics.find((c) => c.id === featuredComics[0])!;

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20hero%20background%2C%20dark%20fantasy%20cityscape%20with%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20manga%20illustration%20style%2C%20cool%20dark%20tones%20with%20warm%20accent%20highlights%2C%20cinematic%20composition&width=1600&height=800&seq=hero-bg-manga-01&orientation=landscape"
        alt="韩国漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center gap-8 md:gap-12">
        <div className="flex-1 text-center md:text-left">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium mb-4 whitespace-nowrap">
            🔥 今日推荐
          </span>
          <h1 className="font-heading text-3xl md:text-5xl text-white mb-4 leading-tight">
            <strong>韩国漫画在线阅读</strong>
            <br />
            <span className="text-primary-400">最新免费漫画大全</span>
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-lg mb-6 leading-relaxed">
            韩漫网站支持<strong>韩国漫画在线阅读</strong>，提供最新免费漫画大全，资源丰富画质佳，每日更新海量韩漫资源，高清画质流畅阅读，是您休闲娱乐的好去处。
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
            <Link
              to="/article/1"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm whitespace-nowrap transition-all duration-200 hover:scale-105"
            >
              开始阅读
            </Link>
            <Link
              to="/category/all"
              className="px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm whitespace-nowrap transition-all duration-200 backdrop-blur-sm border border-white/20"
            >
              浏览全部漫画
            </Link>
          </div>
        </div>

        <div className="hidden md:block flex-shrink-0">
          <Link to={`/article/${featuredComic.id}`} className="block group">
            <div className="relative w-[220px] h-[320px] rounded-xl overflow-hidden ring-2 ring-white/30 group-hover:ring-primary-400 transition-all duration-300 group-hover:scale-105">
              <img
                src={featuredComic.cover}
                alt={featuredComic.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-white text-sm mt-3 text-center font-medium whitespace-nowrap">
              {featuredComic.title}
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
}